import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { CookieService } from 'ngx-cookie-service';
import { ConfirmService } from '../../../core/components/confirm/confirm.service';
import { Cliente } from '../../../core/modelos/cliente';
import { ClientesService } from './clientes.service';
import { User } from '../../../core/modelos/user';
import { LoginService } from '../login/login.service';
import { NotificacionesService } from '../../../core/notificaciones/notificaciones.service';
import { TranslateService } from '@ngx-translate/core';

/**
 * @title Data table with sorting, pagination, and filtering.
 */
@Component({
    selector: 'fuse-clientes-datatable',
    templateUrl: './clientes.component.html',
    styleUrls: ['./clientes.component.scss']
})
export class ClientesComponent implements AfterViewInit {
    displayedColumns = ['id', 'nombre', 'codigo', 'usuarios_utilizados', 'usuarios_totales', 'proyectos_creados', 'max_proyectos', 'acciones'];
    dataSource: MatTableDataSource<Cliente>;

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    // Usuario conectado
    user: { usuario: string };

    clientes: Array<Cliente>;
    static cambiarCliente(cliente: Cliente) {
        const cookie: CookieService = new CookieService(document);
        cookie.set('clienteAdmin', JSON.stringify(cliente));
    }

    constructor(
        public cookieService: CookieService,
        private clientesService: ClientesService,
        private confirmService: ConfirmService,
        private loginService: LoginService,
        private notificaciones: NotificacionesService,
        private translate: TranslateService

    ) {
        const usuarioLogueado: User = JSON.parse(sessionStorage.getItem('usuarioLogueado')).usuario;
        if (usuarioLogueado.rol.id !== 1) {
            this.loginService.logout();
        } else {
            this.getClientes();
        }

    }

    getClientes() {

        this.clientesService.getClientes().subscribe(
            data => {
                if (data.success) {
                    this.clientes = data.items;
                    // Assign the data to the data source for the table to render
                    this.dataSource = new MatTableDataSource(this.clientes);

                    // Esto estaba en el afterViewInit
                    this.dataSource.paginator = this.paginator;
                    this.dataSource.sort = this.sort;

                    // Traduzco etiqueta si es español
                    if (this.translate.currentLang === 'es') {
                        this.paginator._intl.itemsPerPageLabel = this.notificaciones.mensajes.IdiomaActual.MensajesGenerales.ItemsPorPagina;
                    }

                } else {
                    // CONTROLAR ERROR
                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Clientes.SinClientes);
                }
            },
            err => {
                // CONTROLAR ERROR
                this.notificaciones.errorServidor(err.status);
            }
        );

    }

    /**
     * Set the paginator and sort after the view init since this component will
     * be able to query its view for the initialized paginator and sort.
     */
    ngAfterViewInit() {
    }

    applyFilter(filterValue: string) {
        this.dataSource.data = this.clientes;

        if (filterValue && filterValue.trim() !== '') {
            this.dataSource.data = this.dataSource.data.filter(
                cliente => {
                    if (cliente.codigo.toLowerCase().includes(filterValue.toLowerCase())) {
                        return cliente.codigo.toLowerCase().includes(filterValue.toLowerCase());
                    }
                    else if (cliente.nombre.toLowerCase().includes(filterValue.toLowerCase())) {
                        return cliente.nombre.toLowerCase().includes(filterValue.toLowerCase());
                    }
                    // Creo que no tiene sentido filtrar los campos numericos...
                }
            );
        }
    }
    delete(id: number) {
        this.confirmService.confirm(
            this.notificaciones.mensajes.IdiomaActual.Clientes.TituloBorrar,
            this.notificaciones.mensajes.IdiomaActual.Clientes.MensajeBorrar).subscribe(
                result => {
                    if (result) {
                        this.clientesService.deleteCliente(id).subscribe(
                            data => {
                                if (data.success) {
                                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Clientes.ClienteBorrado);
                                    this.getClientes();
                                } else {
                                    // CONTROLAR ERROR
                                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Clientes.ClienteNOBorrado);
                                }
                            },
                            err => {
                                // CONTROLAR ERROR
                                this.notificaciones.errorServidor(err.status);
                            }
                        );
                    }
                }
            );
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/clientes/clientes.component.ts